import React, { FC } from 'react';

interface props {
  children: React.ReactNode;
}

const TableWrapper: FC<props> = ({ children }) => {
  return (
    <div className="border overflow-y-hidden dark:border-gray-700 rounded-lg">
      {children}
    </div>
  );
};

export default TableWrapper;
